import axios from '../../utils/axiosinstance'
// import axios from 'axios'
import moment from 'moment'

const state = {
  kwSelection: [{}],
  kwSelected: {},
  nextReport: {
    meta: {
      maxrunid: 0,
      w_maxrunid: 0,
    },
    constructionreports: {
      dayReports: [],
      weekreports: []
    }
  },
  addNewDiaryPage: false,
  filterTab: false,
  activeOverView: false,
  activePreview: true,
  constructionReports: [],
  selectedReport: {},
  reportDetails: {
    weather: {},
    constructionreport: {
      reportparams: {
        show_projectnumber: false,
        show_creator: false,
        show_constructor: false,
        left_footer: false,
        right_footer: false,
        center_footer: false,

      }
    },
    groups: {},
    staff: {
      shifts: []
    }
  },
  reportsMeta: { maxcount : 1 },
  allReports: [],
  reportPhotos: [],
  selected_report_photos: [],
  photosFiles: [],
  // Used For Edit Report Purpose
  reportDetailsCopy: {
    weather: {},
    constructionreport: { reportparams: {}},
    groups: {},
    staff: {
      shifts: []
    }
  },
  groupTextList: [],
  maxMetaDate: moment(new Date()).add(-100, 'year').format('DD.MM.YYYY'),
  minMetaDate: moment(new Date()).format('DD.MM.YYYY'),


  //Used For Create New Construction Report
  newReport: {
    constructionreportid: "0",
    crdate: moment(new Date()).format('YYYY-MM-DD'),
    created: "",
    creator: "",
    reportstartdate: "",
    footercenter: null,
    footerleft: null,
    footerright: null,
    locked: false,
    pduserid: "1",
    projectid: "",
    revision: "0",
    runid: "0",
    show_misc: "1",
    staffdata: "1",
    staffparams: null,
    status: "0",
    reporttype: "",
    reportparams: {
      // left_footer: true,
      // center_footer: true,
      // right_footer: true,
      // show_projectnumber: true,
      // show_creator: true,
      // show_constructor: true
    },
    unit_humidity: "1",
    unit_speed: "1",
    unit_temperature: "1",
    use_weatherdb: "1",
    weather_zipcode: "",
    weatherdata: "1",
    crurl: null,
    _explicitType: "com\\projectdocu\\ConstructionReportVO"
  },
  lastReport: {},
  activeTextGroupId: null,
  is_loading: false,
  activeTextareaId: null
}

const mutations = {
  setReportAttachedPhotos: (state,payload) => {
    state.reportDetailsCopy.constructionreport.reportparams.attachedPhotos = payload
  },
  setActiveTextareaId: (state,payload) => {
    state.activeTextareaId = payload;
    if (payload){
      state.activeTextGroupId = payload.crgroupid
    }
  },
  setActiveTextValue: (state,payload) => {
    if (state.activeTextareaId.crgroupfieldvalue){
      state.activeTextareaId.crgroupfieldvalue += payload;
    } else {
      state.activeTextareaId.crgroupfieldvalue = payload;
    }
  },
  setLastReport: (state,payload)=> {
    state.lastReport = payload
  },
  setAllConstructionReports: (state,payload)=> {
    state.allReports = payload
  },
  setKwSelection: (state,payload)=> {
    state.kwSelection = payload
  },
  setReportparams: (state,payload)=> {
    state.reportparams = payload
  },
  setKwSelected: (state,payload)=> {
    state.kwSelected = payload
  },
  setNextReportParams: (state,payload)=> {
    state.nextReport = payload
  },
  setSelectedReport: (state,payload)=> {
    state.selectedReport = payload
  },
  setNewConstructionReport: (state,payload)=> {
    state.newReport = payload
  },
  setReportDetailsCopy: (state , payload) => {
    state.reportDetailsCopy = payload
  },
  loading: (state,payload) => {
    state.is_loading = payload
  },
  setConstructionReportDetail: (state, payload) => {
    state.reportDetails = payload
  },
  toggleFilterTab: (state, payload) => {
    state.filterTab = payload
  },
  toggleOverViewTab: (state, payload) => {
    state.activeOverView = payload
  },
  setConstructionReports : (state,payload) => {
    state.constructionReports = payload
  },
  setReportsMeta: (state,payload) => {
    state.reportsMeta = payload
  },
  setReportPhotoFiles: (state,payload) => {
    state.photosFiles = payload
  },
  setReportPhotos: (state,payload) => {
    state.photosFiles = payload
    state.reportPhotos = payload
  },
  setReportSelectedPhotos: (state,payload) => {
    state.selected_report_photos = payload
  },
  toggleAddDiaryPage: (state, payload) => {
    state.filterTab = false
    state.addNewDiaryPage = payload
  },
  setConstructionMetaDateFrom: (state, val) => {
    state.maxMetaDate = val
  },
  setConstructionMetaDateTo: (state, val) => {
    state.minMetaDate = val
  },
  setGroupTextList: (state, val) => {
    if (val){
      state.groupTextList = val.sort((a,b) => b.crtagid - a.crtagid)
    }
  },
  setReporttype: (state, payload) => {
    state.newReport.reporttype = payload
  },
  setRunid: (state, payload) => {
    console.log('SetRunId', payload)
    state.newReport.runid = payload
  }
}
const actions = {
  //Construction dairy list....
  async getConstructionReports({commit,state},payload){
    commit('loading',true);
    console.log('getConstructionRepots')

    if(payload.params) {

      payload.params[4].push(
        {
          "_explicitType":"com\\projectdocu\\OrderSettingVO",
          "fieldname":"revision",
          "order":"DESC"
        });


    }


    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getConstructionReports",
        "parameters": payload.params,
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      const meta = res.data.meta;
      if (meta.maximumDate){
        meta.maximumDate = moment(meta.maximumDate).format('DD.MM.YYYY')
        meta.minimumDate = moment(meta.minimumDate).format('DD.MM.YYYY')
      }
      commit("setReportsMeta",meta)
      if (payload.is_paging){
        commit("setConstructionReports",res.data.constructionreports)
      }
      else {
        let last_report = res.data.constructionreports.find(item => parseInt(item.runid) === res.data.meta.maxrunid)
        commit("setAllConstructionReports",res.data.constructionreports);
        commit("setLastReport",last_report);
        let newReport = state.newReport;
        newReport.runid = parseInt(last_report.runid) + 1;
        commit("setNewConstructionReport",state.newReport);
      }
      commit('loading',false)
    }).catch(error =>{
       console.log(error,"Oops something went wrong")
       commit('loading',false)
    });
  },

  //get weekly reports data
   getConstructionWeeklyReports({commit,state},payload){
    let _this = this
    commit('loading',true)
      axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getNextConstructionReports",
        "parameters": payload.params,
        "serviceName": "ProjectdocuService"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        commit('setKwSelection',res.data.meta.kwselection || {})
        commit('setReportparams',res.data.meta.cr_params || {})
        commit('setReporttype', "D")
        commit('setRunid', parseInt(res.data.meta.maxrunid) + 1)


        res.data.meta.kwselection.map(kw => {
          if(kw.selected) {
            console.log('KW Selected', kw)
            commit('setKwSelected',kw || {})
          }
        })
        commit('setNextReportParams',res.data || {})
      console.log(res,"here is response............")
      commit('loading',false);
    }).catch(error => {
      console.log(error,"oops something went wrong")
      commit('loading',false)
    })
  },

  async getConstructionReportById({commit,state,dispatch},payload){
    commit('loading',true)
    commit("setReportSelectedPhotos",[]);
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getConstructionReportByID",
        "parameters": [payload.id],
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      commit("setConstructionReportDetail",res.data);
      commit("setReportDetailsCopy",res.data);
      dispatch("getReportPhotos",res.data.constructionreport)
      commit('loading',false);
    }).catch(error => {
        console.log(error,"oops something went wrong")
        commit('loading',false)
    } )
  },

  reportPhotosParams({commit},report){
    return [report.projectid, null, 0 ,
      {
        "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO",
        "operands":[
          {
            "_explicitType": "com\\projectdocu\\PredicateOperandBetweenVO",
            "fieldvalueFrom": (report.reporttype == 'W' ? report.reportstartdate : report.crdate),
            "fieldname": "photodate-day",
            "fieldvalueTo": report.crdate
          }
        ],
      },
      [{
        _explicitType: "com\\projectdocu\\OrderSettingVO",
        fieldname: "photodate",
        order: "DESC"
      }]
    ]
  },

  //get photos of report by construction report date
  async getReportPhotos({commit,dispatch},report){
    commit('loading',true)
    let params = await dispatch('reportPhotosParams',report);
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getPhotosOfProject",
        "serviceName": "ProjectdocuService",
        "parameters":   params
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res=> {
      commit('setReportPhotos',res.data.photos);
      const images = report.reportparams.attached_photos;
      if (res.data.photos && images) {
        const selected_images = res.data.photos
          .filter(photo => images.some(img => img.pdphotoid === photo.pdphotoid))
          .map(photo => {
            const matchedImage = images.find(img => img.pdphotoid === photo.pdphotoid);
            return {
              ...photo,
              descriptionextend: matchedImage.descriptionextend // No need for null check
            };
          });
        commit("setReportSelectedPhotos", [...selected_images]);
      }

      // dispatch('getReportImagesFiles',res.data.photos);
         commit('loading', false)
    }).catch(error=> {
      commit('loading', false)
    });
  },

  async getReportImagesFiles({commit,state }, photos) {
    commit("setReportPhotoFiles",[]);
    await  photos.forEach(photo => {
      fetch(`${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.projectid}&id=${photo.pdphotoid}&token=${localStorage.sessiontoken}`,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
          }
        }).then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            photo.src = reader.result
            commit("setReportPhotoFiles",photo);
          }
        }).catch(error => {
        console.log(error)
      });
    });
  },

  async deleteConstructionReport({ commit }, id) {
    commit( 'toggleLoading', true )
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "deleteConstructionReport",
        "serviceName": "ProjectdocuService",
        "parameters": [id]
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.status === 200 || res.statusText === 'OK'){
        this._vm.$toast.success('Bautagebuch gelöscht')
      }
    })
    commit( 'toggleLoading', false )
  },


  async getTextList({ commit }, ids) {
      commit( 'toggleLoading', true )
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "getCRTags",
          "serviceName": "ProjectdocuService",
          "parameters": ids
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        if (res.status === 200 || res.statusText === 'OK'){
          commit('setGroupTextList',res.data)
        }
      });
      commit( 'toggleLoading', false )
    },

  async updateOrCreateText({ commit , dispatch}, data) {
    commit( 'toggleLoading', true )
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "updateCRTag",
        "serviceName": "ProjectdocuService",
        "parameters":[{
          "crtagid": data.text_id,
          "projectid": data.project_id,
          "crgroupfieldid": state.activeTextGroupId,
          "crtagname": data.text,
          "deleted": data.is_delete
        }]}, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.status === 200 || res.statusText === 'OK'){
        dispatch('getTextList',[data.project_id,state.activeTextGroupId]);
        if (data.is_delete) {
          this._vm.$toast.success('Der Text wurde gelöscht')
        } else if (data.text_id) {
          this._vm.$toast.success('Der Text wurde hinzugefügt')
        } else {
          this._vm.$toast.success('Textbaustein wurde aktualisiert')
        }
      }
    });
    commit( 'toggleLoading', false )
  },

  async deleteTextItem({ commit , dispatch}, data) {
    commit( 'toggleLoading', true )
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "deleteCRTag",
        "serviceName": "ProjectdocuService",
        "parameters":[data.project_id, data.text_id],
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.status === 200 || res.statusText === 'OK'){
        dispatch('getTextList',[data.project_id,state.activeTextGroupId]);
        this._vm.$toast.success('Textbaustein wurde gelöscht')
      }
    });
    commit( 'toggleLoading', false )
  },
}
const getters = {

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/constructionDiary.js